import React, { useState } from "react";
import store from "@/redux/store";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { EyeIcon } from '@heroicons/react/24/outline';
import Drawer from "@/controllers/Drawer";
import {invoiceInit, recreateInvoice} from "@/reducers/Invoice";
import { loadCustomer, addCustomer, unsetSelected } from '@/reducers/Customer'
import {showConfirmModal, hideModal} from "@/reducers/ModalPopup";


export function Overview({...props}) {
    const [selectedData, setSelectedData] = useState(null);

const showPreview = (event, item) => {
    event.preventDefault();
    store.dispatch(loadCustomer(item.key));
    setSelectedData({data: item, click: new Date()});
    
    return false;
  }

const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    return false;
  }
  
const recreateInvoiecHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(recreateInvoice({key: item.key}));
    
    return false;
  }
  
  
const confirmedRemoveHandler = (props) => {
    store.dispatch(removeCustomer(props.item.key));
    store.dispatch(hideModal());
}
 
const newInvoice = (event) => {
    //event.preventDefault();
    store.dispatch(invoiceInit());
    
    return true;
}
    
  return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Facturen</h1>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <Link
            //onClick={(event) => newInvoice(event)}
            to="create"
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Nieuwe factuur 
          </Link>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Factuur nummer
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Klant
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Datum
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {props.data && props.data.map((item) => (
                  <tr key={item.key}>
                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        <div className="flex gap-x-6">
                            <EyeIcon className="hidden h-6 w-5 flex-none text-gray-400 sm:block cursor-pointer sm:hidden" onClick={(e) => {showPreview(e, item);}}/>
                            {item.invoice_number}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{JSON.parse(item.customer).name}</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{item.invoice_date}</td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-left text-sm font-medium sm:pr-0 mr-5">
                    {item.state < 9 &&
                      <span className="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                        Processing...
                      </span>
                      }
                    {item.state == 9 &&
                      <span className="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                        Open
                      </span>
                      }
                    {item.state == 99 &&
                      <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-800 ring-1 ring-inset ring-green-600/20">
                        Voldaan
                      </span>
                      }
                      
                    </td>
                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 mr-5">
                    
            <button
              onClick={(e) => {recreateInvoiecHandler(e, item);}}
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opnieuw aanmaken PDF
            </button>

      {item.download_link && item.download_link != "" &&
        <a href={item.download_link} target="_blank">
        Download
        </a>
        }

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
          
          <Drawer data={selectedData} type="invoice" key={new Date()}/>

    </>
      );
}
